import {Checkbox, Col, Form, Input, Select, Radio} from "antd";

import React from "react";
import {IDesignation} from "../types/experience.types";
import {CheckboxGroupProps} from "antd/lib/checkbox";
import AddTags from "../../../../common/tags/add-tags";


const employmentTypes: CheckboxGroupProps<string>['options'] = [
    {
        label: 'Full Time',
        value: 'FULL_TIME'
    },
    {
        label: 'Part Time',
        value: 'PART_TIME'
    },
    {
        label: 'Trainee',
        value: 'TRAINEE'
    },
    {
        label: 'Contract',
        value: 'CONTRACT'
    },
];

interface ICurrentExperienceProps {
    form: any;
    designations: IDesignation[]
}

const CurrentExperience = (props: ICurrentExperienceProps) => {

    function setDesignation(value: string) {
        console.log(props.designations,'designationsssss');
        const selected = props.designations.find(d => d.id === value);
        console.log(selected,'selected')
        props.form.setFieldsValue({
            current: {
                designationId: selected?.id,
                designationCode: selected?.code,
                designationDisplayName: selected?.displayName,
            }
        });
    }

    return (
        <section className={'pn__employee-create__form__fixed-width current-experience'}>
            <Col span={20}>
                <Form.Item
                    name={["current", "companyName"]}
                    label={"Company Name"}
                    className={"formInputFields"}
                    rules={[
                        {
                            required: true,
                            message: 'Please enter the company name',
                        },
                    ]}
                >
                    <Input placeholder={'Enter company name'}/>
                </Form.Item>
            </Col>

            {/*<Col span={20}>*/}
                <Form.Item
                    label="Employment Type"
                    name={["current", "employmentType"]}
                    className="formInputFields"
                    rules={[
                        {
                            required: true,
                            message: 'Please select employment type',
                        },
                    ]}
                >
                    <Radio.Group
                        size='large'
                        style={{display: 'flex', justifyContent: 'space-between'}}
                        name="radiogroup"
                        options={employmentTypes}
                    />

                </Form.Item>
            {/*</Col>*/}

            <Col span={20}>
                <Form.Item
                    label="Designation"
                    name={["current", "designationId"]}
                    className={"formInputFields"}
                    rules={[
                        {
                            required: true,
                            message: 'Please select the designation',
                        },
                    ]}
                >
                    <Select
                        virtual={false}
                        placeholder={'Select designation'}
                        onChange={(value: string) => setDesignation(value)}
                    >
                        {props.designations.map((designation: IDesignation) => (
                            <Select.Option
                                key={designation.id}
                                value={designation.id}
                            >
                                {designation.displayName}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>

            <Form.Item
                name={["current", "designationCode"]}
                hidden={true}
            >
                <Input/>
            </Form.Item>

            <Form.Item
                name={["current", "designationDisplayName"]}
                hidden={true}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label={"Primary Skills"}
                name={["current", "primarySkills"]}
                className={"formInputFields"}
                rules={[
                    {
                        required: true,
                        message: "Please enter primary skills",
                    },
                ]}
            >
                <AddTags tagLabel={'Add Skills'}/>
            </Form.Item>

            <Col span={20}>
                <Form.Item
                    label={"Secondary Skills"}
                    name={["current", "secondarySkills"]}
                    className={"formInputFields"}
                    rules={[
                        {
                            required: true,
                            message: "Please enter secondary skills",
                        },
                    ]}
                >
                    <AddTags tagLabel={'Add Skills'}/>
                </Form.Item>
            </Col>
        </section>
    )
}

export default CurrentExperience;
